export enum HeaderTypes {
    SHOW_HEADER = '@header/SHOW_HEADER',
    HIDE_HEADER = '@header/HIDE_HEADER',
    SHOW_HEADER_MENU = '@header/SHOW_HEADER_MENU',
    HIDE_HEADER_MENU = '@header/HIDE_HEADER_MENU',
}

export interface HeaderState {
    show: boolean;
    showMenu: boolean;
}
